import React, {memo} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import CustomModal from '@buncha/common/components/CustomModal/CustomModal';
import {H3Text} from '@buncha/components/core/text';
import {Modules} from '@buncha/utils/types';
import {PButton} from '@buncha/components/core/Button';
import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const CancelOrderConfirmation = (props: Props) => {
  const muli = useFontTheme('muli');
  const theme = useColorThemeType();
  const mortise = useFontTheme('mortise');
  const {body, button} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.Reschedule) ?? {};

  const {open, onClose, onSubmit} = props;
  return (
    <CustomModal open={open} onClose={onClose}>
      <Box style={styles.bodyContainer}>
        <H3Text
          style={[
            styles.header,
            {fontFamily: mortise[700].normal, color: theme?.text.blue[300]},
          ]}>
          {body?.cancelOrderModal}
        </H3Text>
        <PButton
          title={button?.cancelOrderModal?.confirm}
          style={styles.topButton}
          titleStyle={{
            fontSize: font.FontSize.fontH5.fontSize,
            fontFamily: muli[700].normal,
          }}
          titleColor={theme?.text.white[100]}
          bgColor={theme?.text.red[100]}
          onPress={onSubmit}
        />
        <PButton
          title={button?.cancelOrderModal?.cancel}
          style={styles.buttonButton}
          titleStyle={{
            fontSize: font.FontSize.fontH5.fontSize,
            fontFamily: muli[700].normal,
          }}
          titleColor={theme?.text.gray[100]}
          bgColor={theme?.text.white[100]}
          borderColor={theme?.text.gray[300]}
          onPress={onClose}
        />
      </Box>
    </CustomModal>
  );
};

export default memo(CancelOrderConfirmation);

const styles = StyleSheet.create({
  bodyContainer: {padding: 15},
  header: {marginBottom: 10},
  topButton: {marginBottom: 10, borderRadius: 50},
  buttonButton: {borderRadius: 50, borderWidth: 1},
});
